import { render, staticRenderFns } from "./SavedSearchItem.vue?vue&type=template&id=2da9f895&scoped=true&"
import script from "./SavedSearchItem.vue?vue&type=script&lang=js&"
export * from "./SavedSearchItem.vue?vue&type=script&lang=js&"
import style0 from "./SavedSearchItem.vue?vue&type=style&index=0&id=2da9f895&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da9f895",
  null
  
)

export default component.exports